import FetchFactory from '@repository/factory';
import Routes from '@repository/routes.client';
import type {
    JoinResponse,
    SessionResponse,
    ActiveSessionsResponse,
    ChatsByHostIdsResponse,
    UnreadMessagesResponse,
} from '@repository/types';

class ChatModule extends FetchFactory {
    private readonly RESOURCE = Routes.Chat;

    getActiveSessions() {
        return this.call<ActiveSessionsResponse>({
            url: `${this.RESOURCE.activeSessions()}`,
            method: 'GET',
        });
    }

    getUnreadMessagesAmount() {
        return this.call<UnreadMessagesResponse>({
            url: `${this.RESOURCE.unreadMessages()}`,
            method: 'GET',
        });
    }

    getChatSessionId(hostId: string) {
        return this.call<SessionResponse>({
            url: `${this.RESOURCE.session(hostId)}`,
            method: 'GET',
        });
    }

    joinChat(sessionId: MaybeRef<string>) {
        return this.call<JoinResponse>({
            url: `${this.RESOURCE.join(sessionId)}`,
            method: 'GET',
        });
    }

    getChatsByHostIds(hostIds: MaybeRef<string[]>) {
        return this.call<ChatsByHostIdsResponse>({
            url: `${this.RESOURCE.chatsByHosts()}`,
            method: 'POST',
            body: { hostIds: toValue(hostIds) },
        });
    }

    postMessageSentInfo(sessionId: string) {
        return this.call({
            url: `${this.RESOURCE.markAsSent()}`,
            method: 'POST',
            body: { sessionId },
        });
    }

    postMessageReadInfo(sessionId: string) {
        return this.call({
            url: `${this.RESOURCE.markAsRead()}`,
            method: 'POST',
            body: { sessionId },
        });
    }
}

export default ChatModule;
